<template>
  <div
    ref="selectRef"
    class="company-select"
  >

    <label class="label">
      Компания
    </label>


    <!-- =====================================================
         SELECT
    ====================================================== -->

    <button
      type="button"
      class="select-box"
      :class="{
        open: isOpen,
        selected: !!selectedCompany
      }"
      @click="toggleDropdown"
    >

      <div class="select-left">

        <div class="company-icon">
          <svg
            viewBox="0 0 24 24"
            fill="none"
            aria-hidden="true"
          >
            <path
              d="M5 20V8L12 4L19 8V20"
              stroke="currentColor"
              stroke-width="1.7"
              stroke-linecap="round"
              stroke-linejoin="round"
            />

            <path
              d="M9 20V14H15V20"
              stroke="currentColor"
              stroke-width="1.7"
            />

            <path
              d="M8 9H9"
              stroke="currentColor"
              stroke-width="1.7"
              stroke-linecap="round"
            />

            <path
              d="M12 9H13"
              stroke="currentColor"
              stroke-width="1.7"
              stroke-linecap="round"
            />

            <path
              d="M16 9H17"
              stroke="currentColor"
              stroke-width="1.7"
              stroke-linecap="round"
            />
          </svg>
        </div>


        <div class="selected-content">

          <template v-if="selectedCompany">

            <span class="selected-label">
              Организатор
            </span>

            <span class="selected-name">
              {{ selectedCompany.name }}
            </span>

          </template>


          <template v-else>

            <span class="placeholder">
              Выберите компанию
            </span>

          </template>

        </div>

      </div>


      <div
        class="arrow"
        :class="{ open: isOpen }"
      >
        <svg
          viewBox="0 0 20 20"
          fill="none"
        >
          <path
            d="M6 8L10 12L14 8"
            stroke="currentColor"
            stroke-width="1.8"
            stroke-linecap="round"
            stroke-linejoin="round"
          />
        </svg>
      </div>

    </button>


    <!-- =====================================================
         SELECTED HINT
    ====================================================== -->

    <div
      v-if="selectedCompany"
      class="selected-hint"
    >
      <span class="selected-dot"></span>

      Компания выбрана
    </div>


    <!-- =====================================================
         DROPDOWN
    ====================================================== -->

    <Transition name="dropdown">

      <div
        v-if="isOpen"
        class="dropdown"
      >

        <!-- HEADER -->

        <div class="dropdown-header">

          <div>
            <strong>
              Ваши компании
            </strong>

            <span>
              Выберите организатора ивента
            </span>
          </div>

          <span
            v-if="!loading"
            class="companies-count"
          >
            {{ companies.length }}
          </span>

        </div>


        <!-- LOADING -->

        <div
          v-if="loading"
          class="dropdown-state"
        >

          <div class="loader"></div>

          <span>
            Загружаем компании
          </span>

        </div>


        <!-- COMPANIES -->

        <div
          v-else-if="companies.length"
          class="companies-list"
        >

          <button
            v-for="company in companies"
            :key="company.company_id"
            type="button"
            class="dropdown-item"
            :class="{
              active:
                selectedCompany?.company_id
                === company.company_id
            }"
            @click.stop="selectCompany(company)"
          >

            <!-- LOGO -->

            <div class="company-avatar">

              <img
                v-if="company.image_url"
                :src="company.image_url"
                :alt="company.name || 'Компания'"
              />

              <span v-else>
                {{ companyInitial(company.name) }}
              </span>

            </div>


            <!-- TEXT -->

            <div class="company-info">

              <span class="company-name">
                {{ company.name || "Без названия" }}
              </span>

              <span
                v-if="company.site"
                class="company-site"
              >
                {{ formatCompanySite(company.site) }}
              </span>

              <span
                v-else
                class="company-site"
              >
                Компания Hr3
              </span>

            </div>


            <!-- CHECK -->

            <div
              v-if="
                selectedCompany?.company_id
                === company.company_id
              "
              class="check-icon"
            >
              <svg
                viewBox="0 0 24 24"
                fill="none"
              >
                <path
                  d="M5 12.5L9.5 17L19 7.5"
                  stroke="currentColor"
                  stroke-width="2"
                  stroke-linecap="round"
                  stroke-linejoin="round"
                />
              </svg>
            </div>


            <div
              v-else
              class="item-arrow"
            >
              <svg
                viewBox="0 0 20 20"
                fill="none"
              >
                <path
                  d="M7 5L12 10L7 15"
                  stroke="currentColor"
                  stroke-width="1.7"
                  stroke-linecap="round"
                  stroke-linejoin="round"
                />
              </svg>
            </div>

          </button>

        </div>


        <!-- EMPTY -->

        <div
          v-else
          class="empty-state"
        >

          <div class="empty-icon">
            <svg
              viewBox="0 0 24 24"
              fill="none"
            >
              <path
                d="M5 20V8L12 4L19 8V20"
                stroke="currentColor"
                stroke-width="1.7"
                stroke-linecap="round"
                stroke-linejoin="round"
              />

              <path
                d="M9 20V14H15V20"
                stroke="currentColor"
                stroke-width="1.7"
              />
            </svg>
          </div>

          <strong>
            Компаний пока нет
          </strong>

          <span>
            Создайте компанию, чтобы использовать
            её как организатора ивента.
          </span>

        </div>


        <!-- FOOTER -->

        <div class="dropdown-footer">

          <button
            type="button"
            class="create-company-button"
            @click.stop="goToCreateCompany"
          >

            <div class="create-company-icon">
              +
            </div>

            <div>
              <strong>
                Создать компанию
              </strong>

              <span>
                Добавить нового организатора
              </span>
            </div>

            <svg
              class="create-arrow"
              viewBox="0 0 20 20"
              fill="none"
            >
              <path
                d="M7 5L12 10L7 15"
                stroke="currentColor"
                stroke-width="1.7"
                stroke-linecap="round"
                stroke-linejoin="round"
              />
            </svg>

          </button>

        </div>

      </div>

    </Transition>

  </div>
</template>


<script setup>

import {
  onBeforeUnmount,
  onMounted,
  ref
} from "vue";

import {
  useRouter
} from "vue-router";

import UserService
  from "../../api/UserService";


const emit =
  defineEmits([
    "update:modelValue"
  ]);


const router =
  useRouter();


const selectRef =
  ref(null);

const companies =
  ref([]);

const selectedCompany =
  ref(null);

const loading =
  ref(false);

const isOpen =
  ref(false);

const isLoaded =
  ref(false);


/* ============================================================
   DROPDOWN
============================================================ */

async function toggleDropdown() {

  isOpen.value =
    !isOpen.value;


  if (
    isOpen.value
    && !isLoaded.value
  ) {

    await loadCompanies();

  }

}


/* ============================================================
   LOAD
============================================================ */

async function loadCompanies() {
  try {

    loading.value =
      true;


    const profile =
      await UserService.getProfile();


    const newCompanies =
      Array.isArray(
        profile?.companies
      )
        ? profile.companies
        : [];


    const legacyCompany =
      profile?.current_company
      || null;


    const normalizedCompanies = [
      ...newCompanies
    ];


    if (
      legacyCompany?.company_id
    ) {

      const alreadyExists =
        normalizedCompanies.some(
          company =>
            company.company_id
            === legacyCompany.company_id
        );


      if (!alreadyExists) {

        normalizedCompanies.push(
          legacyCompany
        );

      }

    }


    companies.value =
      normalizedCompanies;


    isLoaded.value =
      true;


    console.log(
      "🏢 Загружены компании:",
      companies.value
    );


  } catch (error) {

    console.error(
      "❌ Ошибка загрузки компаний:",
      error
    );


    companies.value =
      [];


  } finally {

    loading.value =
      false;

  }
}


/* ============================================================
   SELECT
============================================================ */

function selectCompany(company) {

  selectedCompany.value =
    company;


  emit(
    "update:modelValue",
    company
  );


  isOpen.value =
    false;

}


/* ============================================================
   CREATE COMPANY
============================================================ */

function goToCreateCompany() {

  isOpen.value =
    false;


  router.push(
    "/create-company"
  );

}


/* ============================================================
   OUTSIDE CLICK
============================================================ */

function handleOutsideClick(event) {

  if (
    !selectRef.value
  ) {
    return;
  }


  if (
    !selectRef.value.contains(
      event.target
    )
  ) {

    isOpen.value =
      false;

  }

}


onMounted(() => {

  document.addEventListener(
    "mousedown",
    handleOutsideClick
  );

});


onBeforeUnmount(() => {

  document.removeEventListener(
    "mousedown",
    handleOutsideClick
  );

});


/* ============================================================
   HELPERS
============================================================ */

function companyInitial(name) {

  if (!name) {
    return "?";
  }


  return name
    .trim()
    .charAt(0)
    .toUpperCase();

}


function formatCompanySite(site) {

  if (!site) {
    return "";
  }


  return site
    .replace(
      /^https?:\/\//,
      ""
    )
    .replace(
      /^www\./,
      ""
    )
    .replace(
      /\/$/,
      ""
    );

}

</script>


<style scoped>

* {
  box-sizing:
    border-box;
}


/* ============================================================
   ROOT
============================================================ */

.company-select {
  position:
    relative;

  width:
    100%;
}


.label {
  display:
    block;

  margin-bottom:
    8px;

  color:
    #626a75;

  font-family:
    "Eastman-Medium",
    sans-serif;

  font-size:
    10px;
}


/* ============================================================
   SELECT BOX
============================================================ */

.select-box {
  width:
    100%;

  min-height:
    50px;

  display:
    flex;

  align-items:
    center;

  justify-content:
    space-between;

  gap:
    12px;

  padding:
    7px
    12px;

  color:
    #343941;

  background:
    #f8f9fb;

  border:
    1px solid
    rgba(
      31,
      44,
      62,
      0.08
    );

  border-radius:
    12px;

  outline:
    none;

  cursor:
    pointer;

  text-align:
    left;

  transition:
    background-color
    0.2s ease,
    border-color
    0.2s ease,
    box-shadow
    0.2s ease;
}


.select-box:hover {
  background:
    #ffffff;

  border-color:
    rgba(
      52,
      127,
      231,
      0.2
    );
}


.select-box.open {
  background:
    #ffffff;

  border-color:
    rgba(
      52,
      127,
      231,
      0.55
    );

  box-shadow:
    0 0 0 3px
    rgba(
      52,
      127,
      231,
      0.08
    );
}


.select-box.selected {
  background:
    rgba(
      52,
      127,
      231,
      0.035
    );

  border-color:
    rgba(
      52,
      127,
      231,
      0.27
    );
}


.select-left {
  min-width:
    0;

  display:
    flex;

  align-items:
    center;

  gap:
    10px;
}


/* ============================================================
   ICON
============================================================ */

.company-icon {
  width:
    34px;

  height:
    34px;

  flex-shrink:
    0;

  display:
    flex;

  align-items:
    center;

  justify-content:
    center;

  color:
    #31a273;

  background:
    rgba(
      49,
      162,
      115,
      0.085
    );

  border-radius:
    10px;

  transition:
    color
    0.2s ease,
    background
    0.2s ease,
    box-shadow
    0.2s ease;
}


.company-icon svg {
  width:
    17px;

  height:
    17px;
}


.select-box.selected
.company-icon {
  color:
    #ffffff;

  background:
    linear-gradient(
      135deg,
      #3eb880,
      #299a69
    );

  box-shadow:
    0 5px 13px
    rgba(
      46,
      164,
      106,
      0.2
    );
}


/* ============================================================
   SELECTED CONTENT
============================================================ */

.selected-content {
  min-width:
    0;

  display:
    flex;

  flex-direction:
    column;

  gap:
    1px;
}


.selected-label {
  color:
    #9ba1aa;

  font-family:
    "Eastman-Regular",
    sans-serif;

  font-size:
    7px;

  letter-spacing:
    0.05em;

  text-transform:
    uppercase;
}


.selected-name {
  max-width:
    100%;

  overflow:
    hidden;

  color:
    #343941;

  font-family:
    "Eastman-Medium",
    sans-serif;

  font-size:
    11px;

  line-height:
    1.35;

  text-overflow:
    ellipsis;

  white-space:
    nowrap;
}


.placeholder {
  color:
    #a9afb8;

  font-family:
    "Eastman-Regular",
    sans-serif;

  font-size:
    12px;
}


/* ============================================================
   ARROW
============================================================ */

.arrow {
  width:
    28px;

  height:
    28px;

  flex-shrink:
    0;

  display:
    flex;

  align-items:
    center;

  justify-content:
    center;

  color:
    #969da7;

  border-radius:
    8px;

  transition:
    transform
    0.22s ease,
    color
    0.22s ease,
    background-color
    0.22s ease;
}


.arrow svg {
  width:
    15px;

  height:
    15px;
}


.select-box:hover
.arrow {
  color:
    #347fe7;

  background:
    rgba(
      52,
      127,
      231,
      0.06
    );
}


.arrow.open {
  color:
    #347fe7;

  transform:
    rotate(
      180deg
    );
}


/* ============================================================
   SELECTED HINT
============================================================ */

.selected-hint {
  display:
    flex;

  align-items:
    center;

  gap:
    6px;

  margin:
    7px
    0
    0
    4px;

  color:
    #8d949e;

  font-family:
    "Eastman-Regular",
    sans-serif;

  font-size:
    8px;
}


.selected-dot {
  width:
    5px;

  height:
    5px;

  flex-shrink:
    0;

  border-radius:
    50%;

  background:
    #3dbf78;

  box-shadow:
    0 0 0 3px
    rgba(
      61,
      191,
      120,
      0.09
    );
}


/* ============================================================
   DROPDOWN
============================================================ */

.dropdown {
  position:
    absolute;

  top:
    calc(
      100% + 9px
    );

  left:
    0;

  z-index:
    500;

  width:
    100%;

  max-height:
    360px;

  overflow:
    hidden;

  background:
    rgba(
      255,
      255,
      255,
      0.98
    );

  border:
    1px solid
    rgba(
      31,
      44,
      62,
      0.075
    );

  border-radius:
    16px;

  box-shadow:
    0 20px 50px
    rgba(
      25,
      35,
      55,
      0.14
    );

  backdrop-filter:
    blur(
      18px
    );

  -webkit-backdrop-filter:
    blur(
      18px
    );

  transform-origin:
    top;
}


/* ============================================================
   DROPDOWN HEADER
============================================================ */

.dropdown-header {
  display:
    flex;

  align-items:
    center;

  justify-content:
    space-between;

  gap:
    12px;

  padding:
    14px
    15px
    11px;

  border-bottom:
    1px solid
    rgba(
      31,
      44,
      62,
      0.055
    );
}


.dropdown-header > div {
  display:
    flex;

  flex-direction:
    column;

  gap:
    2px;
}


.dropdown-header strong {
  color:
    #454b54;

  font-family:
    "Eastman-Medium",
    sans-serif;

  font-size:
    10px;
}


.dropdown-header span {
  color:
    #9ba1aa;

  font-family:
    "Eastman-Regular",
    sans-serif;

  font-size:
    8px;
}


.companies-count {
  min-width:
    23px;

  padding:
    4px
    7px;

  color:
    #6d7785 !important;

  background:
    #f2f4f7;

  border-radius:
    999px;

  text-align:
    center;

  font-family:
    "Eastman-Bold",
    sans-serif !important;

  font-size:
    8px !important;
}


/* ============================================================
   LIST
============================================================ */

.companies-list {
  max-height:
    235px;

  overflow-y:
    auto;

  padding:
    6px;

  scrollbar-width:
    thin;
}


.dropdown-item {
  width:
    100%;

  display:
    flex;

  align-items:
    center;

  gap:
    10px;

  min-height:
    58px;

  padding:
    8px
    9px;

  color:
    inherit;

  background:
    transparent;

  border:
    none;

  border-radius:
    11px;

  cursor:
    pointer;

  text-align:
    left;

  transition:
    background-color
    0.18s ease,
    transform
    0.18s ease;
}


.dropdown-item:hover {
  background:
    #f5f7fa;

  transform:
    translateX(
      2px
    );
}


.dropdown-item.active {
  background:
    rgba(
      52,
      127,
      231,
      0.065
    );
}


/* ============================================================
   COMPANY AVATAR
============================================================ */

.company-avatar {
  width:
    39px;

  height:
    39px;

  flex-shrink:
    0;

  display:
    flex;

  align-items:
    center;

  justify-content:
    center;

  overflow:
    hidden;

  color:
    #627ca2;

  background:
    linear-gradient(
      135deg,
      #e9eef5,
      #f2f4f7
    );

  border:
    1px solid
    rgba(
      31,
      44,
      62,
      0.055
    );

  border-radius:
    11px;

  font-family:
    "Eastman-Bold",
    sans-serif;

  font-size:
    13px;
}


.company-avatar img {
  width:
    100%;

  height:
    100%;

  display:
    block;

  object-fit:
    cover;
}


/* ============================================================
   COMPANY INFO
============================================================ */

.company-info {
  min-width:
    0;

  flex:
    1;

  display:
    flex;

  flex-direction:
    column;

  gap:
    2px;
}


.company-name {
  overflow:
    hidden;

  color:
    #3a4048;

  font-family:
    "Eastman-Medium",
    sans-serif;

  font-size:
    10px;

  text-overflow:
    ellipsis;

  white-space:
    nowrap;
}


.company-site {
  overflow:
    hidden;

  color:
    #969da7;

  font-family:
    "Eastman-Regular",
    sans-serif;

  font-size:
    8px;

  text-overflow:
    ellipsis;

  white-space:
    nowrap;
}


/* ============================================================
   CHECK / ITEM ARROW
============================================================ */

.check-icon {
  width:
    26px;

  height:
    26px;

  flex-shrink:
    0;

  display:
    flex;

  align-items:
    center;

  justify-content:
    center;

  color:
    #ffffff;

  background:
    linear-gradient(
      135deg,
      #3eb880,
      #299a69
    );

  border-radius:
    8px;

  box-shadow:
    0 5px 12px
    rgba(
      46,
      164,
      106,
      0.17
    );
}


.check-icon svg {
  width:
    13px;

  height:
    13px;
}


.item-arrow {
  width:
    26px;

  height:
    26px;

  flex-shrink:
    0;

  display:
    flex;

  align-items:
    center;

  justify-content:
    center;

  color:
    #adb2ba;

  transition:
    color
    0.18s ease,
    transform
    0.18s ease;
}


.item-arrow svg {
  width:
    13px;

  height:
    13px;
}


.dropdown-item:hover
.item-arrow {
  color:
    #347fe7;

  transform:
    translateX(
      2px
    );
}


/* ============================================================
   LOADING
============================================================ */

.dropdown-state {
  min-height:
    110px;

  display:
    flex;

  flex-direction:
    column;

  align-items:
    center;

  justify-content:
    center;

  gap:
    10px;

  color:
    #969da7;

  font-family:
    "Eastman-Regular",
    sans-serif;

  font-size:
    9px;
}


.loader {
  width:
    24px;

  height:
    24px;

  border:
    2px solid
    rgba(
      52,
      127,
      231,
      0.13
    );

  border-top-color:
    #347fe7;

  border-radius:
    50%;

  animation:
    company-spin
    0.7s
    linear
    infinite;
}


@keyframes company-spin {

  to {
    transform:
      rotate(
        360deg
      );
  }

}


/* ============================================================
   EMPTY
============================================================ */

.empty-state {
  min-height:
    150px;

  display:
    flex;

  flex-direction:
    column;

  align-items:
    center;

  justify-content:
    center;

  padding:
    24px;

  text-align:
    center;
}


.empty-icon {
  width:
    42px;

  height:
    42px;

  display:
    flex;

  align-items:
    center;

  justify-content:
    center;

  margin-bottom:
    10px;

  color:
    #8c94a0;

  background:
    #f2f4f7;

  border-radius:
    12px;
}


.empty-icon svg {
  width:
    19px;

  height:
    19px;
}


.empty-state strong {
  color:
    #525963;

  font-family:
    "Eastman-Medium",
    sans-serif;

  font-size:
    10px;
}


.empty-state > span {
  max-width:
    250px;

  margin-top:
    4px;

  color:
    #999fa9;

  font-family:
    "Eastman-Regular",
    sans-serif;

  font-size:
    8px;

  line-height:
    1.5;
}


/* ============================================================
   FOOTER
============================================================ */

.dropdown-footer {
  padding:
    7px;

  border-top:
    1px solid
    rgba(
      31,
      44,
      62,
      0.055
    );
}


.create-company-button {
  width:
    100%;

  display:
    flex;

  align-items:
    center;

  gap:
    10px;

  padding:
    9px;

  color:
    inherit;

  background:
    transparent;

  border:
    none;

  border-radius:
    11px;

  cursor:
    pointer;

  text-align:
    left;

  transition:
    background-color
    0.18s ease;
}


.create-company-button:hover {
  background:
    rgba(
      52,
      127,
      231,
      0.055
    );
}


.create-company-icon {
  width:
    35px;

  height:
    35px;

  flex-shrink:
    0;

  display:
    flex;

  align-items:
    center;

  justify-content:
    center;

  color:
    #ffffff;

  background:
    linear-gradient(
      135deg,
      #2887f7,
      #486de6
    );

  border-radius:
    10px;

  box-shadow:
    0 6px 14px
    rgba(
      40,
      135,
      247,
      0.17
    );

  font-family:
    "Eastman-Regular",
    sans-serif;

  font-size:
    18px;
}


.create-company-button > div:nth-child(2) {
  min-width:
    0;

  flex:
    1;

  display:
    flex;

  flex-direction:
    column;

  gap:
    2px;
}


.create-company-button strong {
  color:
    #347fe7;

  font-family:
    "Eastman-Medium",
    sans-serif;

  font-size:
    9px;
}


.create-company-button span {
  color:
    #9da3ac;

  font-family:
    "Eastman-Regular",
    sans-serif;

  font-size:
    7px;
}


.create-arrow {
  width:
    14px;

  height:
    14px;

  color:
    #9ba3ae;

  transition:
    transform
    0.18s ease;
}


.create-company-button:hover
.create-arrow {
  transform:
    translateX(
      2px
    );
}


/* ============================================================
   TRANSITION
============================================================ */

.dropdown-enter-active,
.dropdown-leave-active {
  transition:
    opacity
    0.18s ease,
    transform
    0.18s ease;
}


.dropdown-enter-from,
.dropdown-leave-to {
  opacity:
    0;

  transform:
    translateY(-5px)
    scale(0.985);
}


/* ============================================================
   DARK
============================================================ */

html[data-theme="dark"]
.label {
  color:
    #9299a4;
}


html[data-theme="dark"]
.select-box {
  color:
    #eeeeef;

  background:
    #2d2f34;

  border-color:
    rgba(
      255,
      255,
      255,
      0.07
    );
}


html[data-theme="dark"]
.select-box:hover,
html[data-theme="dark"]
.select-box.open {
  background:
    #303238;
}


html[data-theme="dark"]
.select-box.selected {
  background:
    rgba(
      52,
      127,
      231,
      0.08
    );

  border-color:
    rgba(
      69,
      132,
      231,
      0.25
    );
}


html[data-theme="dark"]
.selected-name {
  color:
    #eeeeef;
}


html[data-theme="dark"]
.placeholder {
  color:
    #7e848e;
}


html[data-theme="dark"]
.company-icon {
  color:
    #67b98f;

  background:
    rgba(
      55,
      173,
      114,
      0.11
    );
}


html[data-theme="dark"]
.select-box.selected
.company-icon {
  color:
    #ffffff;
}


html[data-theme="dark"]
.dropdown {
  background:
    rgba(
      38,
      40,
      45,
      0.98
    );

  border-color:
    rgba(
      255,
      255,
      255,
      0.075
    );

  box-shadow:
    0 22px 55px
    rgba(
      0,
      0,
      0,
      0.38
    );
}


html[data-theme="dark"]
.dropdown-header,
html[data-theme="dark"]
.dropdown-footer {
  border-color:
    rgba(
      255,
      255,
      255,
      0.06
    );
}


html[data-theme="dark"]
.dropdown-header strong {
  color:
    #e6e7e9;
}


html[data-theme="dark"]
.companies-count {
  color:
    #aaaeb5 !important;

  background:
    #313339;
}


html[data-theme="dark"]
.dropdown-item:hover {
  background:
    #303238;
}


html[data-theme="dark"]
.dropdown-item.active {
  background:
    rgba(
      69,
      132,
      231,
      0.11
    );
}


html[data-theme="dark"]
.company-avatar {
  color:
    #9aa8bb;

  background:
    linear-gradient(
      135deg,
      #30333a,
      #363940
    );

  border-color:
    rgba(
      255,
      255,
      255,
      0.05
    );
}


html[data-theme="dark"]
.company-name {
  color:
    #eceef0;
}


html[data-theme="dark"]
.company-site {
  color:
    #858b95;
}


html[data-theme="dark"]
.empty-icon {
  color:
    #969da7;

  background:
    #303238;
}


html[data-theme="dark"]
.empty-state strong {
  color:
    #e0e2e5;
}


html[data-theme="dark"]
.create-company-button:hover {
  background:
    rgba(
      69,
      132,
      231,
      0.09
    );
}


/* ============================================================
   MOBILE
============================================================ */

@media (
  max-width:
  600px
) {

  .dropdown {
    max-height:
      330px;
  }


  .companies-list {
    max-height:
      210px;
  }

}


/* ============================================================
   REDUCED MOTION
============================================================ */

@media (
  prefers-reduced-motion:
  reduce
) {

  .select-box,
  .arrow,
  .company-icon,
  .dropdown-item,
  .item-arrow,
  .create-arrow,
  .dropdown-enter-active,
  .dropdown-leave-active {
    transition:
      none;
  }


  .loader {
    animation:
      none;
  }

}

</style>